<template>
	<el-drawer title="聊天记录" size="700px" :visible.sync="isShow" direction="rtl" :before-close="close">
		<div v-loading="loading" class="box-loading">
			<div v-if="showInfo">
				<div class="chat-history">
					<div class="search-bar">
						<el-input class="search-text" size="small" placeholder="搜索聊天记录" v-model="searchText"
							@input="onSearchTextChange" clearable>
							<i class="el-icon-search el-input__icon" slot="prefix"> </i>
						</el-input>
					</div>
					<div class="chat-tabs" ref="chatTabs">
						<el-tabs v-model="tabName" @tab-click="onTabClick">
							<el-tab-pane label="全部" name="all">
								<el-scrollbar v-if="messageSize > 0" ref="allScrollBox" :style="tabPaneStyle">
									<div v-for="(msgInfo, idx) in messages" :key="idx">
										<chat-history-item v-if="idx >= showMinIdx" @click.native="onClickItem(idx)"
											@contextmenu.prevent.native="onRclickItem($event, idx)"
											@dblclick.native="onDblclickItem(idx)" :active="activeIdx == idx"
											:headImage="headImage(msgInfo)" :showName="showName(msgInfo)"
											:quoteShowName="showName(msgInfo.quoteMessage)" :msgInfo="msgInfo">
										</chat-history-item>
									</div>
								</el-scrollbar>
								<no-data-tip v-else :style="tabPaneStyle" :tip="noDataTip"></no-data-tip>
							</el-tab-pane>
							<el-tab-pane label="文字" name="text">
								<el-scrollbar v-if="messageSize > 0" ref="textScrollBox" :style="tabPaneStyle">
									<div v-for="(msgInfo, idx) in messages" :key="idx">
										<chat-history-item v-if="idx >= showMinIdx" @click.native="onClickItem(idx)"
											@contextmenu.prevent.native="onRclickItem($event, idx)"
											@dblclick.native="onDblclickItem(idx)" :active="activeIdx == idx"
											:headImage="headImage(msgInfo)" :showName="showName(msgInfo)"
											:quoteShowName="showName(msgInfo.quoteMessage)" :msgInfo="msgInfo">
										</chat-history-item>
									</div>
								</el-scrollbar>
								<no-data-tip v-else :style="tabPaneStyle" :tip="noDataTip"></no-data-tip>
							</el-tab-pane>
							<el-tab-pane label="图片" name="image">
								<el-scrollbar v-if="messageSize > 0" ref="imageScrollBox" :style="tabPaneStyle">
									<div v-if="tabName == 'image'" class="chat-image-video-list">
										<div v-for="(msgInfo, idx) in messages" :key="idx">
											<div class="chat-image-video" :class="activeIdx == idx ? 'active' : ''"
												@contextmenu.prevent="onRclickItem($event, idx)"
												@dblclick="onDblclickItem(idx)" @click="onClickItem(idx)">
												<img class="image" :src="$mediaUrl(JSON.parse(msgInfo.content).thumbUrl)"
													loading="lazy" @click="showFullImageBox(msgInfo)" />
												<span class="upload-text">{{ showName(msgInfo) }}上传于 {{
													$date.toTimeText(msgInfo.sendTime, true) }} </span>
											</div>
										</div>
									</div>
								</el-scrollbar>
								<no-data-tip v-else :style="tabPaneStyle"></no-data-tip>
							</el-tab-pane>
							<el-tab-pane label="文件" name="file">
								<el-scrollbar v-if="messageSize > 0" ref="fileScrollBox" :style="tabPaneStyle">
									<div v-for="(msgInfo, idx) in messages" :key="idx">
										<chat-history-item v-if="idx >= showMinIdx" @click.native="onClickItem(idx)"
											@contextmenu.prevent.native="onRclickItem($event, idx)"
											@dblclick.native="onDblclickItem(idx)" :active="activeIdx == idx"
											:headImage="headImage(msgInfo)" :showName="showName(msgInfo)"
											:quoteShowName="showName(msgInfo.quoteMessage)" :msgInfo="msgInfo">
										</chat-history-item>
									</div>
								</el-scrollbar>
								<no-data-tip v-else :style="tabPaneStyle" :tip="noDataTip"></no-data-tip>
							</el-tab-pane>
							<el-tab-pane label="语音" name="voice">
								<el-scrollbar v-if="messageSize > 0" ref="voiceScrollBox" :style="tabPaneStyle">
									<div v-for="(msgInfo, idx) in messages" :key="idx">
										<chat-history-item v-if="idx >= showMinIdx" @click.native="onClickItem(idx)"
											@contextmenu.prevent.native="onRclickItem($event, idx)"
											@dblclick.native="onDblclickItem(idx)" :active="activeIdx == idx"
											:headImage="headImage(msgInfo)" :showName="showName(msgInfo)"
											:quoteShowName="showName(msgInfo.quoteMessage)" :msgInfo="msgInfo">
										</chat-history-item>
									</div>
								</el-scrollbar>
								<no-data-tip v-else :style="tabPaneStyle"></no-data-tip>
							</el-tab-pane>
							<el-tab-pane label="视频" name="video">
								<el-scrollbar v-if="messageSize > 0" ref="videoScrollBox" :style="tabPaneStyle">
									<div v-if="tabName == 'video'" class="chat-image-video-list">
										<div v-for="(msgInfo, idx) in messages" :key="idx">
											<div class="chat-image-video" :class="activeIdx == idx ? 'active' : ''"
												@contextmenu.prevent="onRclickItem($event, idx)"
												@dblclick="onDblclickItem(idx)" @click="onClickItem(idx)">
												<video class="video" controls preload="none"
													:poster="$mediaUrl(JSON.parse(msgInfo.content).coverUrl)"
													:src="$mediaUrl(JSON.parse(msgInfo.content).videoUrl)" />
												<span class="upload-text">{{ showName(msgInfo) }}上传于 {{
													$date.toTimeText(msgInfo.sendTime, true) }} </span>
											</div>
										</div>
									</div>
								</el-scrollbar>
								<no-data-tip v-else :style="tabPaneStyle"></no-data-tip>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
				<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
			</div>
		</div>

	</el-drawer>
</template>

<script>
import NoDataTip from '../common/NoDataTip.vue';
import RightMenu from '../common/RightMenu.vue';
import ChatHistoryItem from './ChatHistoryItem.vue';
import ChatMessageItem from './ChatMessageItem.vue';
export default {
	name: 'chatHistory',
	components: {
		ChatMessageItem,
		ChatHistoryItem,
		RightMenu,
		NoDataTip
	},
	props: {
		chat: {
			type: Object
		},
		friend: {
			type: Object
		},
		group: {
			type: Object
		},
		groupMembers: {
			type: Array,
		},
		isShow: {
			type: Boolean,
		},
		propsText: {
			type: String,
			default: '',
		},
	},
	mounted() {
	},
	data() {
		return {
			tabName: "all",
			initEventTabs: [],
			showMinIdx: 0,
			activeIdx: -1,
			searchText: '',
			tabPaneHeight: 500,
			menuItems: [{
				key: 'LOCATE_QUOTE',
				name: '在聊天中定位'
			}],
			loading: false,
			showInfo: false,
			historyLoaded: false,
			historyMessages: []
		}
	},
	watch: {
		isShow() {
			if (this.isShow) {
				this.loading = true;
				this.historyLoaded = false;
				const load = this.$store.dispatch("peekChatHistoryMessages", {
					chat: this.chat,
					maxCount: 8000
				});
				this.timer = setTimeout(() => {
					load.then((list) => {
						if (!this.isShow) {
							return;
						}
						this.historyMessages = list || [];
						this.historyLoaded = true;
						this.showInfo = true;
						this.open();
						this.loading = false;
						this.searchText = this.propsText;
						this.onSearchTextChange();
					}).catch(() => {
						if (!this.isShow) {
							return;
						}
						this.historyMessages = (this.chat && this.chat.messages) || [];
						this.historyLoaded = true;
						this.showInfo = true;
						this.open();
						this.loading = false;
					});
				}, 500)
			} else {
				this.showInfo = false;
				this.historyLoaded = false;
				this.historyMessages = [];
			}
		}
	},
	beforeDestroy() {
		clearTimeout(this.timer);
		this.timer = null;
	},
	methods: {
		open() {
			this.searchText = '';
			this.tabName = 'all';
			this.resetShowMinIdx();
			this.initEvent();
			this.scrollToBottom();
		},
		close() {
			this.$emit('close');
		},
		onTabClick() {
			this.resetShowMinIdx();
			this.initEvent();
			this.scrollToBottom();
		},
		onScroll(e) {
			let scrollElement = e.target
			let scrollTop = scrollElement.scrollTop
			if (scrollTop < 30) {
				// 多展示20条信息
				this.showMinIdx = this.showMinIdx > 20 ? this.showMinIdx - 20 : 0;
			}
		},
		onSearchTextChange() {
			this.resetShowMinIdx();
		},
		onClickItem(idx) {
			this.activeIdx = idx;
		},
		onDblclickItem(idx) {
			this.activeIdx = idx;
			this.onSelectMenu(this.menuItems[0]);
		},
		onRclickItem(e, idx) {
			this.activeIdx = idx;
			this.$refs.rightMenu.open(e, this.menuItems)
		},
		onSelectMenu(item) {
			// 菜单id转驼峰作为事件key
			let eventKey = item.key.toLowerCase().replace(/_([a-z])/g, (g) => g[1].toUpperCase());
			this.$emit(eventKey, this.messages[this.activeIdx]);
		},
		resetShowMinIdx() {
			this.showMinIdx = this.messageSize > 30 ? this.messageSize - 30 : 0;
		},
		initEvent() {
			if (!this.messageSize || this.initEventTabs.indexOf(this.tabName) >= 0) {
				return;
			}
			this.$nextTick(() => {
				let scrollBoxName = this.tabName + "ScrollBox";
				let scrollWrap = this.$refs[scrollBoxName].$el.querySelector('.el-scrollbar__wrap');

				scrollWrap.addEventListener('scroll', this.onScroll);
				this.initEventTabs.push(this.tabName);
			})
		},
		showName(msgInfo) {
			if (!msgInfo)
				return '';
			if (this.isGroup) {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.showNickName : msgInfo.sendNickName || "";
			}
			if (msgInfo.sendId == this.mine.id || msgInfo.selfSend) {
				return this.mine.nickName;
			}
			if (msgInfo.sendId && this.chat && String(msgInfo.sendId) !== String(this.chat.targetId)) {
				return msgInfo.sendNickName || "未知用户";
			}
			return this.chat.showName
		},
		headImage(msgInfo) {
			if (this.isGroup) {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.headImage : "";
			}
			if (msgInfo.sendId == this.mine.id || msgInfo.selfSend) {
				return this.mine.headImage;
			}
			if (msgInfo.sendId && this.chat && String(msgInfo.sendId) !== String(this.chat.targetId)) {
				return msgInfo.headImage || "";
			}
			return this.chat.headImage
		},
		showMenu(e) {
			this.rightMenu.pos = {
				x: e.x,
				y: e.y
			};
			this.rightMenu.show = "true";
		},
		showFullImageBox(msgInfo) {
			let imageUrl = JSON.parse(msgInfo.content).originUrl;
			if (imageUrl) {
				this.$store.commit('showFullImageBox', this.$mediaUrl(imageUrl));
			}
		},
		scrollToBottom() {
			if (!this.messageSize) {
				return;
			}
			this.$nextTick(() => {
				let scrollBoxName = this.tabName + "ScrollBox";
				let scrollWrap = this.$refs[scrollBoxName].$el.querySelector('.el-scrollbar__wrap');
				scrollWrap.scrollTop = scrollWrap.scrollHeight;
			});
		}
	},
	computed: {
		mine() {
			return this.$store.state.userStore.userInfo;
		},
		isGroup() {
			return this.chat.type == 'GROUP';
		},
		historySource() {
			if (this.historyLoaded) {
				return this.historyMessages || [];
			}
			return (this.chat && this.chat.messages) || [];
		},
		allMessage() {
			return this.historySource.filter(m => this.$msgType.isNormal(m.type));
		},
		imageMessage() {
			let type = this.$enums.MESSAGE_TYPE.IMAGE;
			return this.historySource.filter(m => m.type == type);
		},
		fileMessage() {
			let type = this.$enums.MESSAGE_TYPE.FILE;
			return this.historySource.filter(m => m.type == type);
		},
		videoMessage() {
			let type = this.$enums.MESSAGE_TYPE.VIDEO;
			return this.historySource.filter(m => m.type == type);
		},
		voiceMessage() {
			let type = this.$enums.MESSAGE_TYPE.AUDIO;
			return this.historySource.filter(m => m.type == type);
		},
		textMessage() {
			let type = this.$enums.MESSAGE_TYPE.TEXT;
			return this.historySource.filter(m => m.type == type);
		},
		messages() {
			return this[this.tabName + 'Message'].filter(m => {
				if (!this.searchText) {
					return true;
				}
				// 只有文字和文件支持检索
				if (this.tabName != 'all' && this.tabName != 'text' && this.tabName != 'file') {
					return true;
				}
				if (this.$enums.MESSAGE_TYPE.TEXT == m.type) {
					return m.content.toLowerCase().includes(this.searchText.toLowerCase())
				} else if (this.$enums.MESSAGE_TYPE.FILE == m.type) {
					return JSON.parse(m.content).name.toLowerCase().includes(this.searchText.toLowerCase());
				}
				return false;
			});
		},
		messageSize() {
			return this.messages.length;
		},
		tabPaneStyle() {
			return `height:calc(100vh - 175px);`;
		},
		noDataTip() {
			return this.searchText ? `未搜索到与'${this.searchText}'相关的内容` : "没有数据";
		}
	}
}
</script>

<style lang="scss">
.chat-history {
	display: flex;
	height: 100%;
	padding: 0 25px;
	flex-direction: column;

	.search-bar {
		margin-bottom: 10px;
	}

	.chat-tabs {
		flex: 1;

		.chat-image-video-list {
			display: flex;
			flex-wrap: wrap;

			.chat-image-video {
				display: flex;
				flex-direction: column;
				padding: 10px;
				width: 140px;
				border-radius: 5px;
				cursor: pointer;

				.image {
					width: 140px;
					height: 140px;
					border-radius: 5px;
					object-fit: cover;
				}

				.video {
					width: 140px;
					height: 140px;
					border-radius: 5px;
					object-fit: cover;
				}

				.upload-text {
					color: var(--im-text-color-light);
					font-size: var(--im-font-size-small);
					margin-top: 5px;
					word-break: break-all;
				}

				&:hover {
					background: #f4f4f4;
				}

				&.active {
					background: #E1EAF7;
				}
			}

		}
	}
}

.box-loading {
	width: 100%;
	height: 100%;
}
</style>